import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import { dateProvider } from '@/helpers/date'

export default (schema: ISchema): ISchema => {
	const order = [...(schema.order ?? [])]
	const firstTitle = order.findIndex((entry) => (Array.isArray(entry) ? entry[0] : entry) === 'PaywallTitle')

	order[firstTitle] = [
		'PaywallTitle',
		({ $t, ctx }): PaywallComponentProps.Title => ({
			title: ctx.removeDiscount
				? $t('pages.program.title_original')
				: `Grab your plan before it's gone — <span style="color: var(--Text-Rose)">75% off this ${dateProvider.toWeekday(
						new Date(),
					)}!</span>`,
		}),
	]

	return mergeDeep(
		{ ...schema },
		{
			order,
			components: {
				PaywallCountdown: (): PaywallComponentProps.Countdown => ({
					text: `${dateProvider.toWeekday(new Date())} offer ends in {time} min`,
				}),
			},
		},
	)
}
